import { Box } from '@factorialco/deprecated-design-system'

import { dateBackendToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import Attachments from 'modules/bookkeepers/components/IncidenceInformation/Attachments'
import type { Files } from 'modules/bookkeepers/store/collections/files'
import type IncidenceDetail from 'modules/bookkeepers/store/models/IncidenceDetail'

import DetailLine from '../_DetailLine'

interface LeaveInfoProps {
  incidenceDetailModel: IncidenceDetail
  incidenceFilesCollection: Files
}

const LeaveInfo = ({ incidenceDetailModel, incidenceFilesCollection }: LeaveInfoProps) => {
  const termination_date = (date?: string) => {
    if (!date) {
      return i18n.t('bookkeepers.incidence.details.no_end_date')
    }

    return dateBackendToUI(date)
  }

  const hoursCount = parseFloat(incidenceDetailModel.attributes.hours)
  const isTypeInHours = !!hoursCount

  const detailTypeValue = () => {
    if (isTypeInHours) {
      return i18n.tp('bookkeepers.incidence.details.hours', { count: hoursCount })
    }
    if (incidenceDetailModel.attributes.half_day) {
      return i18n.t('bookkeepers.incidence.details.half_day')
    }
    return i18n.t('bookkeepers.incidence.details.full_day')
  }

  return (
    <Box gap="s16">
      {incidenceDetailModel.has('start_on') && (
        <DetailLine
          component="li"
          title={i18n.t('bookkeepers.incidence.details.starts_on')}
          value={dateBackendToUI(incidenceDetailModel.attributes.start_on)}
        />
      )}
      {incidenceDetailModel.has('finish_on') && (
        <DetailLine
          component="li"
          title={i18n.t('bookkeepers.incidence.details.ends_on')}
          value={termination_date(incidenceDetailModel.attributes.finish_on)}
        />
      )}
      {(incidenceDetailModel.has('half_day') || isTypeInHours) && (
        <DetailLine
          component="li"
          title={i18n.t('bookkeepers.incidence.details.type')}
          value={detailTypeValue()}
        />
      )}
      {incidenceDetailModel.has('description') && (
        <DetailLine
          component="li"
          title={i18n.t('bookkeepers.incidence.details.description')}
          value={incidenceDetailModel.attributes.description}
        />
      )}
      {incidenceFilesCollection.length > 0 && (
        <Attachments
          label={i18n.t('bookkeepers.incidence.details.attachments')}
          files={incidenceFilesCollection.models}
        />
      )}
    </Box>
  )
}

export default LeaveInfo
